<template>
	<div>
		<v-dialog v-model="dialog_period_selection" no-click-animation persistent scrollable transition="dialog-bottom-transition">
	      <v-card>
	        <v-card-title noshadow nopadding>
        		<v-subheader full-width>{{title}}</v-subheader>
        	</v-card-title>

	        <!-- <v-divider></v-divider> -->

	        <v-card-text dialog-card-content>
	            <v-layout wrap>

	              	<v-form data-vv-scope="fields" full-width>

			        	<v-flex xs12 sm12 md12 form-item @click="openDatePicker('start', startDate)">
			               	<v-text-field  
			               		readonly 
			               		:value="fn_getStartDate()" 
			               		label="Start Date" 
			               		placeholder=" " 
			               		append-icon="arrow_drop_down"
			               		v-validate="'required'" 
			               		name="startDate"
			               		data-vv-name="startDate" 
			               		:error-messages="errors.collect('fields.startDate')"
			               		required>
			               	</v-text-field>

			            </v-flex>

			            <v-flex xs12 sm12 md12 form-item @click="openDatePicker('end', endDate)">
			               	<v-text-field  
			               		readonly 
			               		:value="fn_getEndDate()"
			               		label="End Date" 
			               		placeholder=" " 
			               		append-icon="arrow_drop_down"
			               		v-validate="'required'" 
			               		name="endDate"
			               		data-vv-name="endDate" 
			               		:error-messages="errors.collect('fields.endDate')"
			               		required>
			               	</v-text-field>

			            </v-flex>

						<v-flex xs12 sm12 md12 redcolor pt-2 pl-3 pr-3 pb-1 v-if="!isDateSelectionValid">
                            Invalid date selection
                        </v-flex>

                        <v-flex xs12 sm12 md12 grey-back pl-3 pr-3 pt-1 pb-1 v-if="!isDateSelectionValid">
                            Note: Start date should be less than end date.
                        </v-flex>
	              	</v-form>

	            </v-layout>

	        </v-card-text>

	        <!-- <v-divider></v-divider> -->

	        <v-card-actions>
	          <v-spacer></v-spacer>
	          <v-btn color="blue darken-1" flat @click="fn_closeDialog" v-if="!hideCancel">close</v-btn>
	          <v-btn color="blue darken-1" flat @click="fn_action" :disabled="!isDateSelectionValid">Done</v-btn>
	        </v-card-actions>
	      </v-card>
	    </v-dialog>
	</div>
</template>

<script>
export default{
	props:['title', 'closeDialog', 'openDatePicker', 'startDate', 'endDate', 'actionMethod', 'hideCancel'],
	data(){	
		return{
			dialog_period_selection: false
		}
	},
	methods:{
		openDialogWeb: function () {
			this.dialog_period_selection = true;
		},
		closeDialogWeb: function () {
			this.dialog_period_selection = false;
		},
		fn_closeDialog: function(){
			this.closeDialog ? this.closeDialog() : this.dialog_period_selection = false;
		},
		fn_getStartDate: function(){
			return this.$moment(this.startDate).format('DD-MMM-YYYY');
		},
		fn_getEndDate: function(){
			return this.$moment(this.endDate).format('DD-MMM-YYYY');
		},
		fn_action: function(){
			if(this.actionMethod){
				this.fn_closeDialog();
				this.actionMethod();
			}
			else{
				this.fn_closeDialog();
			}
		}
	},
	computed:{
		isDateSelectionValid: function(){
			if(new Date(this.startDate) > new Date(this.endDate)){
				return false;
			}
			else{
				return true;
			}
		}
	}
}
</script>


// WEBPACK FOOTER //
// src/components/dialogs/dialog_period_selection.vue